import { render, staticRenderFns } from "./ElementoDrag.vue?vue&type=template&id=061ddd08"
import script from "./ElementoDrag.vue?vue&type=script&lang=js"
export * from "./ElementoDrag.vue?vue&type=script&lang=js"
import style0 from "./ElementoDrag.vue?vue&type=style&index=0&id=061ddd08&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports